import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ProfileComponentEffects } from 'src/app/recruiting/candidates/new-profile/store/profile-component.effects';
import { candidateProfileComponentsReducer } from 'src/app/recruiting/candidates/new-profile/store/profile-component.reducer';
import { profileComponentFeatureKey } from 'src/app/recruiting/candidates/new-profile/store/profile-component.selectors';

export const provideCandidateProfileComponentStore = (): EnvironmentProviders[] => [
    provideState(profileComponentFeatureKey, candidateProfileComponentsReducer),
    provideEffects([ProfileComponentEffects])
];
